module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appointment-form"
  }, [_c('div', {
    staticClass: "d-flex mb-2 mt-4"
  }, [_c('h4', {
    staticClass: "flex-grow-1"
  }, [_vm._v("Afspraak maken")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "title": "Afspraak maken"
    },
    on: {
      "click": function($event) {
        return _vm.create()
      }
    }
  }, [(!_vm.isCreatingAppointment) ? _c('fa-icon', {
    attrs: {
      "icon": "save"
    }
  }) : _c('loader-spinner', {
    attrs: {
      "iscolor": "#F0F0F0",
      "show-spinner": true
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": "Sluit"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "jumbotron py-4"
  }, [_c('autocomplete-person', {
    attrs: {
      "label": "Zoek een persoon"
    },
    on: {
      "update:person": _vm.loadPerson
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.form.person_id) ? _c('span', {
    staticClass: "appointment-form-subtitle"
  }, [_vm._v("Of voer de afspraakgegevens in:")]) : _vm._e(), _vm._v(" "), _c('form', [_c('general-input', {
    staticClass: "mb-2",
    attrs: {
      "label": "Naam",
      "placeholder": "Voer een naam in",
      "disabled": !!_vm.form.person_id
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('general-input', {
    staticClass: "mb-2",
    attrs: {
      "inputType": "email",
      "label": "Email",
      "placeholder": "info@onderdeboompjes.nl",
      "disabled": !!_vm.form.person_id
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }), _vm._v(" "), _c('general-input', {
    staticClass: "mb-2",
    attrs: {
      "inputType": "tel",
      "label": "Telefoonnummer",
      "placeholder": "Voer een telefoonnummer in",
      "disabled": !!_vm.form.person_id
    },
    model: {
      value: (_vm.form.telephone),
      callback: function($$v) {
        _vm.$set(_vm.form, "telephone", $$v)
      },
      expression: "form.telephone"
    }
  }), _vm._v(" "), _c('general-input', {
    attrs: {
      "inputType": "textarea",
      "label": "Opmerkingen",
      "placeholder": "Voer een opmerking in"
    },
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96a326b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Planning/AppointmentForm.vue
// module id = 1331
// module chunks = 1